import styled from '@emotion/styled';
import { Box } from '@kc-console/common-ui';
import { getInitialPropsStatusWrapper } from '@kc-console/guard';
import { ActionTemporaryError, NotFound } from '@kc-console/shared-ui';

import type { NextPageWithLayout } from '@/application/types';

import { noLayout } from '@/application/layouts';

interface ErrorPageProps {
  statusCode: number;
}

const ErrorPage: NextPageWithLayout<ErrorPageProps> = ({ statusCode }) => {
  return (
    <LayoutContainer>
      {statusCode === 404 ? <NotFound /> : <ActionTemporaryError />}
    </LayoutContainer>
  );
};

const LayoutContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  min-height: 800px;
`;

ErrorPage.getCustomLayout = noLayout;
ErrorPage.getInitialProps = getInitialPropsStatusWrapper();

export default ErrorPage;
